exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btn-outline-secondary[data-v-2aa24e8a] {\n    border-color: rgb(140, 140, 140);\n    border-left: none;\n}\n.input-with-addon[data-v-2aa24e8a] {\n    border-right: none;\n}\n.required[data-v-2aa24e8a] {\n  color: red;\n  font-weight: 400\n}\n", ""]);

// exports
